import React from 'react';
import {Modal} from 'react-spaceship-web';
import {Link} from 'react-router-dom';
import {Helper} from './Helper';

export default class ProductDisplay extends React.Component {
	constructor(props) {
		super(props);
		let _state = {
			product_displays: [],
		};
		window.Route.on({
			'/v2/product-display': () => {
				_state = {
					mode: 'list',
					product_displays: [],
				};
			},
			'/v2/product-display/:product_display_id': (params) => {
				_state = {
					mode: 'view',
					params: params,
					product_displays: [],
				};
			},
		}).match();
		_state.is_loading = true;
		this.state = _state;
	}

	componentDidUpdate(prevProps) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			window.Route.on({
				'/v2/product-display': () => {
					this.setState({
						mode: 'list',
						is_table_loading: true,
					}, () => {
						this.fetch();
					})
				},
				'/v2/product-display/:product_display_id': (params) => {
					this.setState({
						mode: 'view',
						params: params,
						is_table_loading: true,
					}, () => {
						this.view();
					});
				}
			}).match();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.fetch();
		}
	}

	edit() {

	}

	prepare() {

	}

	componentDidMount() {
		if (this.state.mode === 'view') {
			this.view();
		}
	}


	view() {
		let data = {};
		data.product_display_id = this.state.params.product_display_id;
		data.request_data_product_display_using_filter = true;
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product-display',
			data: data,
			done: (response) => {
				this.setState({
					is_loading: false,
					product_display: response.product_display[0],
				});
			},
			fail: () => {

			}
		});
	}

	getStatus(product_display) {
		return (
			<div>
				{
					product_display.is_disable
						?
						<span className="ui label grey">งดใช้ชั่วคราว</span>
						: null
				}
				{
					product_display.is_already_in_cart
						?
						<span className="ui label yellow">ไม่สามารถแก้ไข</span>
						: null
				}
				{
					product_display.is_void
						?
						<span className="ui label red">ยกเลิก</span>
						: null
				}
				{
					product_display.is_ready
					&& !product_display.is_disable
						?
						<span className="ui label green">พร้อมจำหน่าย</span>
						: null
				}
			</div>
		)
	}


	renderView() {
		if (!this.state.product_display) {
			return null;
		}

		return (
			<div ref={(ref) => {
				this.$parent = ref;
			}} className="main ui container">
				<div className="flex row wrap middle-xs">
					<div className="ui huge breadcrumb">
						<a href={process.env.REACT_APP_DOMAIN + "/product-display"}
						   className="active section">การแสดงผลสินค้า</a>
						<span className="divider big-margin">/</span>
						<Link className="section"
						      to={"/v2/product-display/" + this.state.product_display.id}>
							{this.state.product_display.name}
						</Link>
					</div>
					<div className="right floated">
						<button className="ui button blue"
						        onClick={() => {
							        window.Global.reactToDom(
								        window.$('body'),
								        <ProductDisplayEditModal
									        mode="edit"
									        onEditedSuccess={(response) => {
										        this.setState({
											        product_display: {...response.product_display}
										        });
									        }}
									        void={() => {
										        this.void()
									        }}
									        product_display={this.state.product_display}
								        />
							        );
						        }}>แก้ไข
						</button>
					</div>
				</div>
				<ProductDisplayViewMenu id={this.state.product_display.id} index={0}/>
				<div className="ui tall padded stacked segment">
					<form className="ui form" autoComplete="off">
						<h2 className="ui dividing header flex row middle-xs between-xs">
							<span>{this.state.product_display.name}</span>
							{this.getStatus(this.state.product_display)}
						</h2>
						<br/>

						<div className="flex row padded wrap two column computer">
							<div className="column flex display-level">
								<h3 className="ui header dividing">ลักษณะสินค้า</h3>
								<div className='tr parent'
								     onClick={(e) => {
									     if (window.$(e.target).closest('.td.span12').length === 0) return;
									     window.$(e.target).closest('.display-level').toggleClass('child-hide');
								     }}
								     style={{borderBottom: 0}}>
									<div className='td span12'>
										<div>
											{
												this.state.product_display.product_display_using_product_variation.map((product_display_using_product_variation, i) => {
													return (
														<ProductDisplayUsingProductVariation
															mode="view"
															key={'p' + window.Global.getRandomInt(1, 99999999)}
															onEditProductDisplayUsingProductVariation={() => {
																window.Global.ajax({
																	method: 'GET',
																	url: process.env.REACT_APP_DOMAIN + '/api/product-display',
																	data: {
																		product_display_id: this.state.product_display.id,
																	},
																	done: (response) => {
																		if (!response.success) {
																			return false;
																		}
																		this.setState({
																			product_display: response.product_display[0]
																		});
																	}
																});
															}}
															product_display={this.state.product_display}
															product_display_using_product_variation={product_display_using_product_variation}
														/>
													)
												})
											}
										</div>
									</div>
									<div className='td span4'>
										<div className="flex row middle-xs">

											<button className="ui button mini"
											        type={"button"}
											        style={{
												        display: this.state.product_display.is_already_in_cart
													        ? 'none'
													        : 'initial'
											        }}
											        onClick={(e) => {
												        window.$(e.target).closest('.display-level').removeClass('child-hide');
												        window.Global.reactToDom(
													        window.$('body'),
													        <ProductDisplayUsingProductVariation
														        mode="create"
														        onCreated={(response) => {
															        this.setState({
																        product_display: {...response.product_display}
															        });
														        }}
														        product_display_using_product_variation={{
															        id: '',
															        product_display_id: this.state.product_display.id,
															        product_variation_id: '',
														        }}
													        />
												        );
											        }}>
												เพิ่มลักษณะสินค้า
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="column">
								<h3 className="ui header dividing">ผูกลักษณะสินค้ากับทะเบียนสินค้า</h3>
								{
									this.state.product_display.product_display_link.map((product_display_link) => {
										if (this.state.product_display.is_already_in_cart
											&& product_display_link.unitReadable
										) {
											return (
												<div key={'b' + window.Global.getRandomInt(1, 9999999)}>
													<b>{product_display_link.product.name + ' ' + product_display_link.unitReadable.quantity2}</b>
												</div>
											)
										}
										return (
											<div key={'b' + window.Global.getRandomInt(1, 9999999)}
											     style={{marginBottom: '1rem'}}>
												<h5>
													{
														product_display_link.product_display_link_detail.map((product_display_link_detail) => {
															return (
																product_display_link_detail.product_variation.name + ' ' + product_display_link_detail.product_variation_item.name + ', '
															)
														})
													}
												</h5>
												<div className="flex row wrap padded">
													<div className="padded col-xs-10"
													     ref={(ref) => {
														     if (!ref) return;

														     let $ratio = window.$(ref).closest('.row').find('.ratio');
														     let is_ready_for_update = false;

														     let onChange = (product, quantity, ratio) => {
															     window.GlobalFunc.setupQuantityAndRatio($ratio, {
																     product: product,
																     quantity: parseFloat(quantity),
																     input_quantity: 'product_display_link[][quantity]',
																     ratio: parseFloat(ratio),
																     input_ratio: 'product_display_link[][ratio]',
																     quantityReadOnly: true,
																     onChange: (item) => {
																	     if (!is_ready_for_update) return;
																	     // console.log(item);
																	     window.$(ref).closest('.ui.segment').addClass('loading');
																	     window.Global.ajax({
																		     method: 'PUT',
																		     url: process.env.REACT_APP_DOMAIN + '/api/product_display/link',
																		     data: {
																			     product_display_link_id: product_display_link.id,
																			     product_id: product.id,
																			     quantity: item.quantity,
																			     ratio: item.ratio,
																		     },
																		     done: (response) => {
																			     window.$(ref).closest('.ui.segment').removeClass('loading');
																			     if (!response.success) {
																				     window.Global.messageTop({
																					     type: 'negative',
																					     message: response.message[0].error_message
																				     });
																				     return false;
																			     }
																			     this.view();
																		     }
																	     });
																     }
															     });
														     };

														     window.$(ref).find('input[type="text"]').explorer({
															     url: process.env.REACT_APP_DOMAIN + '/api/product',
															     additionalData: function () {
																     return {
																	     page: 1,
																	     limit: 10
																     };
															     },
															     key: 'product',
															     template: {
																     list: function (value) {
																	     return window.GlobalTemplate.getProductSearchList('', value);
																     },
																     selected: {
																	     text: 'name',
																	     value: 'id',
																	     placeholder: 'เลือกสินค้า'
																     }
															     },
															     onSelected: (product) => {
																     onChange(product, product.sell_price[0].ratio, product.sell_price[0].ratio);
															     },
															     onUnSelected: () => {
																     window.$(ref).closest('.ui.segment').addClass('loading');
																     window.Global.ajax({
																	     method: 'PUT',
																	     url: process.env.REACT_APP_DOMAIN + '/api/product_display/link/unlink',
																	     data: {
																		     product_display_link_id: product_display_link.id,
																	     },
																	     done: (response) => {
																		     window.$(ref).closest('.ui.segment').removeClass('loading');
																		     if (!response.success) {
																			     window.Global.messageTop({
																				     type: 'negative',
																				     message: response.message[0].error_message
																			     });
																			     return false;
																		     }
																		     this.view();
																	     }
																     });
															     }
														     });

														     if (product_display_link.product) {
															     window.$(ref).find('.Explorer').explorer('set selected', product_display_link.product);
															     onChange(
																     product_display_link.product,
																     product_display_link.ratio,
																     product_display_link.ratio
															     );
														     }

														     is_ready_for_update = true;
													     }}>
														<input type="text" name="product"/>
													</div>
													<div className="padded col-xs-6">
														<div className="ratio"/>
													</div>
												</div>
											</div>
										)
									})
								}
							</div>
							{
								this.state.product_display.description
									?
									<div className="column">
										<h3 className="ui header dividing">รายละเอียด</h3>
										<div className={"white-space-pre-line"}>
											{this.state.product_display.description}
										</div>
									</div>
									: null
							}
						</div>
					</form>
					<div style={{marginTop: '1rem'}}
					     ref={(ref) => {
						     if (!ref) return;

						     if (window.$(ref).find('.Explorer').length > 0) {
							     return;
						     }

						     window.$(ref).find('input').explorer({
							     url: process.env.REACT_APP_DOMAIN + '/api/filter',
							     additionalData: function () {
								     return {
									     type: 'product_display_category',
									     is_has_child: 0,
								     }
							     },
							     allowAdditions: false,
							     multiple: true,
							     key: 'filter',
							     template: {
								     list: function (value) {
									     return window.Handlebars.compile('<div class="item">\n    <div class="flex">\n        <div><b>{{name}}</b></div>\n    </div>\n</div>')(value);
								     },
								     selected: {
									     text: 'name',
									     value: 'name',
									     placeholder: ''
								     }
							     },
							     onSelected: (filter) => {
								     window.Global.ajax({
									     method: 'POST',
									     url: process.env.REACT_APP_DOMAIN + '/api/product_display_using_filter',
									     data: {
										     product_display_id: this.state.product_display.id,
										     filter_id: filter.id,
									     },
									     done: function (response) {
										     if (!response.success) {
											     return false;
										     }
										     window.Global.messageTop({
											     type: 'positive',
											     message: 'บันทึกข้อมูลเรียบร้อย'
										     });
									     }
								     });
							     },
							     onUnSelected: (filter) => {
								     window.Global.ajax({
									     method: 'DELETE',
									     url: process.env.REACT_APP_DOMAIN + '/api/product_display_using_filter',
									     data: {
										     product_display_id: this.state.product_display.id,
										     filter_id: filter.id,
									     },
									     done: function (response) {
										     if (!response.success) {
											     return false;
										     }
										     window.Global.messageTop({
											     type: 'positive',
											     message: 'บันทึกข้อมูลเรียบร้อย'
										     });
									     }
								     });
							     }
						     });

						     window.$.each(this.state.product_display.product_display_using_filter, (i, product_display_using_filter) => {
							     window.$(ref).find('.Explorer[data-explorer_input_name="filter[]"]').explorer(
								     'set selected',
								     product_display_using_filter.filter
							     );
						     });
					     }}>
						<p><b>ระบุหมวดหมู่สินค้า</b></p>
						<input type="text" name="filter[]"/>
					</div>
				</div>
			</div>
		);
	}

	renderList() {
		return null;
	}

	render() {
		if (this.state.mode === 'list') return this.renderList();
		if (this.state.mode === 'view') return this.renderView();
		return null
	}

	void() {
		window.Global.confirm({
			title: 'ยืนยันลบข้อมูล',
			content: '<form class="ui form">\n\t<p>โปรดยืนยันลบข้อมูล การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>',
			cancel_text: 'ไม่ดำเนินการ',
			approve_text: 'ลบข้อมูล',
			onShowToSetupForm: ($modal) => {
				$modal.find('form').form2('setup');
				$modal.find('form').form2('submit', {
					method: 'DELETE',
					url: process.env.REACT_APP_DOMAIN + '/api/product-display',
					loadingButton: $modal.find('.button.approve'),
					beforeSent: (data) => {
						data.product_display_id = this.state.product_display.id;
						return data;
					},
					onSuccess: (response) => {
						$modal.modal('hide');
						window.Global.messageTop({
							type: 'positive',
							message: 'ลบข้อมูลสำเร็จ'
						});
						//this.props.onEditedSuccess(response);
						this.setState({
							product_display: {...response.product_display}
						});
					}
				});
			}
		});
	}

}

class ProductDisplayEditModal extends React.Component {
	render() {
		return (
			<div>
				<Modal className="ui modal small"
				       onShowToSetupForm={($modal) => {
					       if (this.props.mode === 'create') {
						       $modal.find('form').form2('setup');
						       $modal.find('form').form2('submit', {
							       method: 'POST',
							       url: process.env.REACT_APP_DOMAIN + '/api/product-display',
							       beforeSent: function (object) {
								       return object;
							       },
							       loadingButton: $modal.find('.button.approve'),
							       onSuccess: (response) => {
								       $modal.modal('hide');
								       window.Global.messageTop({
									       type: 'positive',
									       message: 'บันทึกข้อมูลเรียบร้อย'
								       });
								       window.router.navigate('/product-display/' + response['product_display']['id'], true);
							       }
						       });
					       }
					       if (this.props.mode === 'edit') {
						       $modal.find('form').form2('setup');
						       //this.prepare();
						       $modal.find('form').form2('submit', {
							       method: 'PUT',
							       url: process.env.REACT_APP_DOMAIN + '/api/product-display',
							       beforeSent: function (object) {
								       return object;
							       },
							       loadingButton: $modal.find('.button.approve'),
							       onSuccess: (response) => {
								       $modal.modal('hide');
								       window.Global.messageTop({
									       type: 'positive',
									       message: 'บันทึกข้อมูลเรียบร้อย'
								       });
								       this.props.onEditedSuccess(response);
							       }
						       });
					       }
				       }}>
					<div className="header">
						<h2>
							{
								this.props.mode === 'create'
									? "สร้างการแสดงผลสินค้า"
									: "แก้ไขการแสดงผลสินค้า"
							}
							{
								this.props.product_display.name
									?
									<span>{" "}·{" "}{this.props.product_display.name}</span>
									: null
							}
						</h2>
					</div>
					<div className="content">
						<form className="ui form">
							<input type="hidden"
							       name="product_display_id"
							       defaultValue={this.props.product_display.id}/>
							<div className="flex row wrap column one column computer padded">
								<div className="column field required">
									<label htmlFor="">ชื่อ</label>
									<input type="text"
									       name="name"
									       defaultValue={this.props.product_display.name}/>
								</div>
								<div className="column field required">
									<label htmlFor="">รายละเอียด</label>
									<textarea name={"description"}
									          defaultValue={this.props.product_display.description || ''}/>
								</div>
								<div className="column field">
									<div className="ui checkbox">
										<input type="checkbox"
										       name="is_disable"
										       defaultChecked={this.props.product_display.is_disable}
										       id="r2"
										/>
										<label htmlFor="r2">งดใช้ชั่วคราว</label>
									</div>
								</div>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							{
								this.props.mode === 'edit'
									? <div className="ui red button"
									       onClick={() => {
										       this.props.void();
									       }
									       }>ลบข้อมูล</div>
									: null
							}
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve green right button">บันทึกข้อมูล</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}

class ProductDisplayUsingProductVariation extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			mode: this.props.mode,
			product_display_using_product_variation: this.props.product_display_using_product_variation || null,
		};
	}

	renderView() {
		return (
			<div style={{margin: '0 0 1rem 0'}}>
				<div className="flex row wrap middle-xs">
					<div onClick={() => {
						window.Global.reactToDom(
							window.$('body'),
							<ProductDisplayUsingProductVariation
								mode="edit"
								onEdited={() => {
									this.props.onEditProductDisplayUsingProductVariation();
								}}
								product_display_using_product_variation={this.state.product_display_using_product_variation}
							/>
						);
					}}>
						<i className="icon pencil"/>
					</div>
					{
						!this.props.product_display.is_already_in_cart
							?
							<div onClick={() => {
								window.Global.reactToDom(
									window.$('body'),
									<ProductDisplayUsingProductVariation
										mode="void"
										onVoided={() => {
											this.props.onEditProductDisplayUsingProductVariation();
										}}
										product_display_using_product_variation={this.state.product_display_using_product_variation}
									/>
								);
							}}>
								<i className="icon trash"/>
							</div> : null
					}
					{
						!this.props.product_display.is_already_in_cart
							?
							<div onClick={() => {
								window.Global.reactToDom(
									window.$('body'),
									<ProductDisplayUsingProductVariationItem
										mode="create"
										onCreated={() => {
											this.props.onEditProductDisplayUsingProductVariation();
										}}
										product_display_using_product_variation={this.state.product_display_using_product_variation}
									/>
								);
							}}>
								<i className="icon plus"/>
							</div> : null
					}
					<div style={{fontSize: '1.3rem'}}>
						<b>{this.state.product_display_using_product_variation.product_variation.name}</b>
					</div>
				</div>
				{
					this.state.product_display_using_product_variation.product_display_using_product_variation_item.map((product_display_using_product_variation_item, i) => {
						return (
							<div key={i}>
								<ProductDisplayUsingProductVariationItem
									mode={"view"}
									onVoided={() => {
										this.props.onEditProductDisplayUsingProductVariation();
									}}
									onEdited={() => {
										this.props.onEditProductDisplayUsingProductVariation();
									}}
									product_display={this.props.product_display}
									product_display_using_product_variation_item={product_display_using_product_variation_item}
								/>
							</div>
						);
					})
				}
			</div>
		);
	}

	renderEdit() {
		return (
			<div>
				<Modal className="ui modal tiny"
				       onShowToSetupForm={($modal) => {
					       $modal.find('form').form2('setup', {});
					       $modal.find('form').form2('submit', {
						       method: 'PUT',
						       url: process.env.REACT_APP_DOMAIN + '/api/product-display/product_display_using_product_variation',
						       beforeSent: function (object) {
							       return object;
						       },
						       loadingButton: $modal.find('.button.approve'),
						       onSuccess: (response) => {
							       $modal.modal('hide');
							       window.Global.messageTop({
								       type: 'positive',
								       message: 'บันทึกข้อมูลเรียบร้อย'
							       });
							       this.props.onEdited(response);
						       }
					       });
				       }}>
					<div className="header">
						<h2>ลักษณะสินค้า</h2>
					</div>
					<div className="content">
						<form className="ui form">
							<input type="hidden"
							       name="product_display_using_product_variation_id"
							       defaultValue={this.state.product_display_using_product_variation.id}
							/>
							<input type="hidden"
							       name="product_display_id"
							       defaultValue={this.state.product_display_using_product_variation.product_display_id}
							/>
							<div className="flex row wrap one column computer padded">
								<input type="hidden"
								       name="product_variation[id]"
								       defaultValue={this.state.product_display_using_product_variation.product_variation.id}
								/>
								<div className="column field">
									<label htmlFor="">ตั้งชื่อลักษณะสินค้า</label>
									<input type="text"
									       name="product_variation[name]"
									       defaultValue={this.state.product_display_using_product_variation.product_variation.name}
									/>
								</div>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve green right button">บันทึกข้อมูล</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}

	renderVoid() {
		return (
			<div>
				<Modal className="ui modal tiny"
				       onShowToSetupForm={($modal) => {
					       $modal.find('form').form2('setup', {});
					       $modal.find('form').form2('submit', {
						       method: 'DELETE',
						       url: process.env.REACT_APP_DOMAIN + '/api/product-display/product_display_using_product_variation',
						       beforeSent: function (object) {
							       return object;
						       },
						       loadingButton: $modal.find('.button.approve'),
						       onSuccess: (response) => {
							       $modal.modal('hide');
							       window.Global.messageTop({
								       type: 'positive',
								       message: 'ลบข้อมูลเรียบร้อย'
							       });
							       this.props.onVoided(response);
						       }
					       });
				       }}>
					<div className="header">
						<h2>ยืนยันลบลักษณะสินค้า</h2>
					</div>
					<div className="content">
						<form className="ui form">
							<input type="hidden"
							       name="product_display_using_product_variation_id"
							       defaultValue={this.state.product_display_using_product_variation.id}
							/>
							<p>โปรดยืนยันลบข้อมูล โปรดระมัดระวังการกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve red right button">ลบข้อมูล</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}

	render() {
		if (this.state.mode === 'view') return this.renderView();
		if (this.state.mode === 'edit') return this.renderEdit();
		if (this.state.mode === 'void') return this.renderVoid();

		return (
			<div>
				<Modal className="ui modal tiny"
				       onShowToSetupForm={($modal) => {
					       if (this.state.mode === 'create') {
						       $modal.find('form').form2('setup', {
							       'is_create_product_variation_onChange': (is_create_product_variation) => {
								       this.setState({
									       product_display_using_product_variation: {
										       ...this.state.product_display_using_product_variation,
										       is_create_product_variation: parseInt(is_create_product_variation)
									       }
								       });
							       }
						       });
						       $modal.find('form').form2('submit', {
							       method: 'POST',
							       url: process.env.REACT_APP_DOMAIN + '/api/product-display/product_display_using_product_variation',
							       beforeSent: function (object) {
								       return object;
							       },
							       loadingButton: $modal.find('.button.approve'),
							       onSuccess: (response) => {
								       $modal.modal('hide');
								       window.Global.messageTop({
									       type: 'positive',
									       message: 'บันทึกข้อมูลเรียบร้อย'
								       });
								       this.props.onCreated(response);
							       }
						       });
					       }
				       }}>
					<div className="header">
						<h2>ลักษณะสินค้า</h2>
					</div>
					<div className="content">
						<form className="ui form">
							<input type="hidden"
							       name="product_display_using_product_variation_id"
							       defaultValue={this.state.product_display_using_product_variation.id}
							/>
							<input type="hidden"
							       name="product_display_id"
							       defaultValue={this.state.product_display_using_product_variation.product_display_id}
							/>
							<div className="flex row wrap one column computer padded">
								<div className="column inline fields">
									<label htmlFor="fruit">ประเภท:</label>
									<div className="field">
										<div className="ui radio checkbox"
										     data-form2_setup="true">
											<input type="radio"
											       name="is_create_product_variation"
											       value="0"
											       defaultChecked={true} tabIndex="0"
											       className="hidden"/>
											<label>เดิม</label>
										</div>
									</div>
									<div className="field">
										<div className="ui radio checkbox"
										     data-form2_setup="true">
											<input type="radio"
											       name="is_create_product_variation"
											       value="1"
											       tabIndex="0" className="hidden"/>
											<label>ใหม่</label>
										</div>
									</div>
								</div>
								{
									!this.state.product_display_using_product_variation.is_create_product_variation
										? <div className="column field"
										       ref={(ref) => {
											       if (!ref) return;
											       if (window.$(ref).find('.Explorer').length === 0) {
												       window.$(ref).find('input[type="text"]').explorer({
													       url: process.env.REACT_APP_DOMAIN + '/api/product_variation',
													       additionalData: {},
													       key: 'product_variation',
													       template: {
														       list: function (product_variation) {
															       return window.Handlebars.compile('<div class="item">\n\t<div class="flex row">\n\t\t<div>\n\t\t\t<b>{{name}}</b>\n\t\t</div>\n\t</div>\n</div>')(product_variation);
														       },
														       selected: {
															       display_template: '{{name}}',
															       value: 'id',
															       placeholder: 'เลือกลักษณะสินค้า'
														       }
													       },
													       onSelected: (product_variation) => {
														       this.setState({
															       product_display_using_product_variation: {
																       ...this.state.product_display_using_product_variation,
																       product_variation: product_variation
															       }
														       });
													       }
												       });
											       }
										       }}>
											<label htmlFor="">ค้นหาลักษณะสินค้า</label>
											<input type="text" name="product_variation[id]"/>
										</div>
										: null
								}
								{
									this.state.product_display_using_product_variation.is_create_product_variation
										?
										<div className="column field">
											<label htmlFor="">ตั้งชื่อลักษณะสินค้า</label>
											<input type="text" name="product_variation[name]"/>
										</div>
										: null
								}
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve green right button">บันทึกข้อมูล</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}

class ProductDisplayUsingProductVariationItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			mode: this.props.mode,
			product_display_using_product_variation: this.props.product_display_using_product_variation || null,
			product_display_using_product_variation_item: this.props.product_display_using_product_variation_item || {},
		};
	}

	renderView() {
		return (
			<div className="flex row wrap middle-xs"
			     style={{paddingLeft: 30}}>
				<div onClick={() => {
					window.Global.reactToDom(
						window.$('body'),
						<ProductDisplayUsingProductVariationItem
							mode="edit"
							onEdited={() => {
								this.props.onEdited();
							}}
							product_display_using_product_variation_item={this.state.product_display_using_product_variation_item}
						/>
					);
				}}>
					<i className="icon pencil"/>
				</div>
				{
					!this.props.product_display.is_already_in_cart
						?
						<div onClick={() => {
							window.Global.reactToDom(
								window.$('body'),
								<ProductDisplayUsingProductVariationItem
									mode="void"
									onVoided={() => {
										this.props.onVoided();
									}}
									product_display_using_product_variation_item={this.state.product_display_using_product_variation_item}
								/>
							);
						}}>
							<i className="icon trash"/>
						</div> : null
				}
				<div className="ui label basic">
					{this.state.product_display_using_product_variation_item.product_variation_item.name}
				</div>
			</div>
		);
	}

	renderEdit() {
		return (
			<div>
				<Modal className="ui modal tiny"
				       onShowToSetupForm={($modal) => {
					       $modal.find('form').form2('setup', {});
					       $modal.find('form').form2('submit', {
						       method: 'PUT',
						       url: process.env.REACT_APP_DOMAIN + '/api/product-display/product_display_using_product_variation/item',
						       beforeSent: function (object) {
							       return object;
						       },
						       loadingButton: $modal.find('.button.approve'),
						       onSuccess: (response) => {
							       $modal.modal('hide');
							       window.Global.messageTop({
								       type: 'positive',
								       message: 'บันทึกข้อมูลเรียบร้อย'
							       });
							       this.props.onEdited(response);
						       }
					       });
				       }}>
					<div className="header">
						<h2>ลักษณะสินค้า</h2>
					</div>
					<div className="content">
						<form className="ui form">
							<input type="hidden"
							       name="product_display_using_product_variation_item_id"
							       defaultValue={this.state.product_display_using_product_variation_item.id}
							/>
							<div className="flex row wrap one column computer padded">
								<input type="hidden"
								       name="product_variation_item[id]"
								       defaultValue={this.state.product_display_using_product_variation_item.product_variation_item.id}
								/>
								<div className="column field">
									<label htmlFor="">ชื่อลักษณะสินค้า</label>
									<input type="text"
									       name="product_variation_item[name]"
									       defaultValue={this.state.product_display_using_product_variation_item.product_variation_item.name}
									/>
								</div>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve green right button">บันทึกข้อมูล</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}

	renderVoid() {
		return (
			<div>
				<Modal className="ui modal tiny"
				       onShowToSetupForm={($modal) => {
					       $modal.find('form').form2('setup', {});
					       $modal.find('form').form2('submit', {
						       method: 'DELETE',
						       url: process.env.REACT_APP_DOMAIN + '/api/product-display/product_display_using_product_variation/item',
						       beforeSent: function (object) {
							       return object;
						       },
						       loadingButton: $modal.find('.button.approve'),
						       onSuccess: (response) => {
							       $modal.modal('hide');
							       window.Global.messageTop({
								       type: 'positive',
								       message: 'ลบข้อมูลเรียบร้อย'
							       });
							       this.props.onVoided(response);
						       }
					       });
				       }}>
					<div className="header">
						<h2>ยืนยันลบลักษณะสินค้า</h2>
					</div>
					<div className="content">
						<form className="ui form">
							<input type="hidden"
							       name="product_display_using_product_variation_item_id"
							       defaultValue={this.state.product_display_using_product_variation_item.id}
							/>
							<p>โปรดยืนยันลบข้อมูล โปรดระมัดระวังการกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve red right button">ลบข้อมูล</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}

	render() {
		if (this.state.mode === 'view') return this.renderView();
		if (this.state.mode === 'edit') return this.renderEdit();
		if (this.state.mode === 'void') return this.renderVoid();

		return (
			<div>
				<Modal className="ui modal tiny"
				       onShowToSetupForm={($modal) => {
					       $modal.find('form').form2('setup', {
						       'is_create_product_variation_item_onChange': (is_create_product_variation_item) => {
							       this.setState({
								       product_display_using_product_variation_item: {
									       ...this.state.product_display_using_product_variation_item,
									       is_create_product_variation_item: parseInt(is_create_product_variation_item)
								       }
							       });
						       }
					       });
					       $modal.find('form').form2('submit', {
						       method: 'POST',
						       url: process.env.REACT_APP_DOMAIN + '/api/product-display/product_display_using_product_variation/item',
						       beforeSent: function (object) {
							       return object;
						       },
						       loadingButton: $modal.find('.button.approve'),
						       onSuccess: (response) => {
							       $modal.modal('hide');
							       window.Global.messageTop({
								       type: 'positive',
								       message: 'บันทึกข้อมูลเรียบร้อย'
							       });
							       this.props.onCreated(response);
						       }
					       });
				       }}>
					<div className="header">
						<h2>ลักษณะสินค้า : {this.state.product_display_using_product_variation.name}</h2>
					</div>
					<div className="content">
						<form className="ui form">
							<input type="hidden"
							       name="product_display_using_product_variation_id"
							       defaultValue={this.state.product_display_using_product_variation.id}
							/>
							<input type="hidden"
							       name="product_display_id"
							       defaultValue={this.state.product_display_using_product_variation.product_display_id}
							/>
							<div className="flex row wrap one column computer padded">
								<div className="column inline fields">
									<label htmlFor="fruit">ประเภท:</label>
									<div className="field">
										<div className="ui radio checkbox"
										     data-form2_setup="true">
											<input type="radio"
											       name="is_create_product_variation_item"
											       value="0"
											       defaultChecked={true} tabIndex="0"
											       className="hidden"/>
											<label>เดิม</label>
										</div>
									</div>
									<div className="field">
										<div className="ui radio checkbox"
										     data-form2_setup="true">
											<input type="radio"
											       name="is_create_product_variation_item"
											       value="1"
											       tabIndex="0" className="hidden"/>
											<label>ใหม่</label>
										</div>
									</div>
								</div>
								{
									!this.state.product_display_using_product_variation_item.is_create_product_variation_item
										? <div className="column field"
										       ref={(ref) => {
											       if (!ref) return;
											       if (window.$(ref).find('.Explorer').length === 0) {
												       window.$(ref).find('input[type="text"]').explorer({
													       url: process.env.REACT_APP_DOMAIN + '/api/product_variation/item',
													       additionalData: {
														       product_variation_id: this.state.product_display_using_product_variation.product_variation.id,
													       },
													       key: 'product_variation_item',
													       template: {
														       list: function (product_variation_item) {
															       return window.Handlebars.compile('<div class="item">\n\t<div class="flex row">\n\t\t<div>\n\t\t\t<b>{{name}}</b>\n\t\t</div>\n\t</div>\n</div>')(product_variation_item);
														       },
														       selected: {
															       display_template: '{{name}}',
															       value: 'id',
															       placeholder: 'เลือกลักษณะสินค้า'
														       }
													       },
													       onSelected: (product_variation_item) => {
														       this.setState({
															       product_display_using_product_variation_item: {
																       ...this.state.product_display_using_product_variation_item,
																       product_variation_item: product_variation_item
															       }
														       });
													       }
												       });
											       }
										       }}>
											<label htmlFor="">ค้นหาลักษณะสินค้า</label>
											<input type="text" name="product_variation_item[id]"/>
										</div>
										: null
								}
								{
									this.state.product_display_using_product_variation_item.is_create_product_variation_item
										?
										<div className="column field">
											<label htmlFor="">ตั้งชื่อลักษณะสินค้า</label>
											<input type="text" name="product_variation_item[name]"/>
										</div>
										: null
								}
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve green right button">บันทึกข้อมูล</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}


export class ProductDisplayViewMenu extends React.Component {
	render() {
		return (
			<div className="ui menu flex row wrap Setting_menu">
				<Link className={this.props.index === 0 ? "item active" : "item"}
				      to={"/v2/product-display/" + this.props.id}>รายละเอียด</Link>
				<Link className={this.props.index === 1 ? "item active" : "item"}
				      to={"/v2/product-display-permission/" + this.props.id}>สิทธิ์มองเห็นคู่ค้า</Link>
			</div>
		);
	}
}


export class ProductDisplayCondition extends React.Component {
	constructor(props) {
		super(props);
		let _state = {
			qs: window.Global.getAllQueryStrings(),
			product_display_permission: [],
		};
		window.Route.on({
			'/v2/product-display-permission/:product_display_id': (params) => {
				_state = {
					mode: 'view',
					params: params,
					product_display_permission: [],
				};
			},
		}).match();
		_state.is_table_loading = true;
		_state.page = 1;
		this.state = _state;
	}

	componentDidUpdate(prevProps) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			window.Route.on({
				'/v2/product-display-permission/:product_display_id': (params) => {
					this.setState({
						mode: 'view',
						params: params,
						qs: Helper.searchToObject(this.props.location.search),
						is_table_loading: true,
					}, () => {
						this.view();
					});
				}
			}).match();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.setState({
				qs: Helper.searchToObject(this.props.location.search),
				is_table_loading: true,
			}, () => {
				this.view();
			});
		}
	}

	componentDidMount() {
		if (this.state.mode === 'view') {
			this.view();
		}
	}


	view() {
		let data = {};
		data.product_display_id = this.state.params.product_display_id;
		data.request_data_product_display_using_filter = true;
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product-display',
			data: data,
			done: (response) => {
				if (!response.success) {
					return false;
				}
				// console.log(response);
				let product_display = response['product_display'][0];

				let data = {...this.state.qs};
				data.product_display_id = product_display.id;
				data.product_display_permission_id = '';
				data.page = this.state.page;
				window.Global.ajax({
					method: 'GET',
					url: process.env.REACT_APP_DOMAIN + '/api/product_display_permission',
					data: data,
					done: (response) => {
						if (!response.success) {
							return false;
						}
						this.setState({
							product_display: product_display,
							product_display_permission: response['product_display_permission'],
							is_table_loading: false,
						}, () => {
							let $search = this.$parent.find('#Search_root');
							window.Search.init({
								$node: $search,
								onSubmit: (data) => {
									this.props.history.push(window.Global.getQueryStringLinkFromObject(data));
									return false;
								}
							});

							$search.find('input[name="relationship_id"]').explorer({
								url: process.env.REACT_APP_DOMAIN + '/api/relationship',
								additionalData: {
									limit: 10,
									page: 1
								},
								key: 'relationship',
								template: {
									list: '<a class="item flex row">{{name}}</a>',
									selected: {
										text: 'name',
										value: 'id',
										placeholder: 'คู่ค้า'
									}
								}
							});

							$search.find('input[name="relationship_group_id"]').explorer({
								url: process.env.REACT_APP_DOMAIN + '/api/relationship/group',
								additionalData: {
									limit: 10,
									page: 1
								},
								key: 'relationship_group',
								template: {
									list: '<a class="item flex row">{{name}}</a>',
									selected: {
										text: 'name',
										value: 'id',
										placeholder: 'กลุ่มคู่ค้า'
									}
								}
							});

							if (response.relationship) {
								$search.find('input[name="relationship_id"]').explorer('set value', response.relationship);
							}

							if (response.relationship_group) {
								$search.find('input[name="relationship_group_id"]').explorer('set value', response.relationship_group);
							}

							this.$parent.find('.table').tablePagination({
								disableContent: true,
								size: response['product_display_permission'].length,
								count: response.count,
								onClickPagination: (p) => {
									let qs = window.Global.getAllQueryStrings();
									qs.page = p;
									this.props.history.push(window.Global.getQueryStringLinkFromObject(qs));
								}
							});
						});
					}
				});
			}
		});
	}

	renderView() {
		// if (!this.state.product_price_condition) return null;

		return (
			<div ref={(ref) => {
				this.$parent = window.$(ref);
			}} className="main ui container">
				<div className="flex row wrap middle-xs">
					<div className="ui huge breadcrumb">
						<a href={process.env.REACT_APP_DOMAIN + "/product-display"}
						   className="active section">การแสดงผลสินค้า</a>
						{
							this.state.product_display ?
								<>
									<span className="divider big-margin">/</span>
									<Link className="section"
									      to={"/v2/product-display/" + this.state.product_display.id}>
										{this.state.product_display.name}
									</Link>
								</>
								: null
						}
						<span className="divider big-margin">/</span>
						<div className="section">
							สิทธิ์มองเห็นคู่ค้า
						</div>
					</div>
					<div className="right floated">
						<button onClick={() => {
							let product_display_permission = [...this.state.product_display_permission];
							product_display_permission.push({
								// id: 'xz' + Global.getRandomInt(1, 1000000),
								product_display_id: this.state.product_display.id,
							});
							this.setState({
								product_display_permission: product_display_permission
							});
						}}
						        className="ui button primary">เพิ่มรายชื่อ
						</button>
					</div>
				</div>
				<ProductDisplayViewMenu id={this.state.params.product_display_id} index={1}/>
				<div id="Search_root" className="box" style={{marginTop: '1rem'}}>
					<form className="ui form">
						<div className="flex row wrap padded five column computer" style={{padding: 0}}>
							<div className="column field">
								<label htmlFor="">ค้นหาคู่ค้า</label>
								<input type="text" name="relationship_id"/>
							</div>
							<div className="column field">
								<label htmlFor="">ค้นหากลุ่มคู่ค้า</label>
								<input type="text" name="relationship_group_id"/>
							</div>
							<div className="column field">
								<label>อื่นๆ</label>
								<div className="flex">
									<div className="ui checkbox">
										<input type="checkbox"
										       name="is_all"
										       value={1}
										       id="r2"/>
										<label htmlFor="r2">คู่ค้าทุกคน</label>
									</div>
								</div>
							</div>
							<div className="column field right floated fluid">
								<div className="field">
									<label htmlFor="" style={{opacity: 0}}>.</label>
									<button className="ui icon button right floated" type="submit">
										<i className="search icon"/> ค้นหา
									</button>
								</div>
							</div>
						</div>
					</form>
				</div>

				<div className="ui basic table Table_root">
					<div className="thead">
						<div className="tr">
							<div className="th span12">รายชื่อ</div>
							<div className="th span4">ประเภท</div>
						</div>
					</div>
					<div className="tbody Item_root">
						{
							this.state.is_table_loading ?
								<div className="tr">
									<div className="td center aligned" data-info="nodata">
										<div className="ui active centered inline small loader"/>
									</div>
								</div>
								: null
						}

						{
							!this.state.is_table_loading
							&& this.state.product_display_permission.length > 0 ?
								this.state.product_display_permission.map((_product_display_permission, i) => {
									return (
										<ProductDisplayConditionPermission
											key={'xz' + window.Global.getRandomInt(1, 1000000)}
											mode={'view'}
											product_display_permission={_product_display_permission}
											onCreated={() => {
												this.view();
											}}
											onDeleted={() => {
												let product_display_permission = this.state.product_display_permission.filter((_product_display_permission, _i) => {
													return i !== _i
												});
												this.setState({
													product_display_permission: product_display_permission
												});
											}}
										/>
									)
								})
								: null
						}
						{
							!this.state.is_table_loading
							&& this.state.product_display_permission.length === 0
								?
								<div className="tr">
									<div className='td span16' style={{textAlign: 'center'}}>
										ไม่มีข้อมูล
									</div>
								</div>
								: null
						}
					</div>
				</div>
			</div>
		);
	}

	render() {
		if (this.state.mode === 'view') return this.renderView();
		if (this.state.mode === 'list') return this.renderList();

		return null;
	}
}

class ProductDisplayConditionPermission extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.props.product_display_permission || {};
	}

	componentDidMount() {

		if (!this.state.id) {
			this.$parent.form2('setup', {
				'is_relationship_group_onChange': (is_relationship_group) => {
					if (is_relationship_group === '1') {
						this.$parent.find('#relationship').hide();
						this.$parent.find('#relationship_group').show();

						setTimeout(() => {
							this.$parent.find('div[data-explorer_input_name="search_relationship_group"] input[name="search"]').focus();
						}, 50);
					}
					if (is_relationship_group === '0') {
						this.$parent.find('#relationship').show();
						this.$parent.find('#relationship_group').hide();

						setTimeout(() => {
							this.$parent.find('div[data-explorer_input_name="search_relationship"] input[name="search"]').focus();
						}, 50);
					}
					if (is_relationship_group === 'null') {
						this.$parent.find('#relationship').hide();
						this.$parent.find('#relationship_group').hide();

						this.$parent.find('input[name="search_relationship"]').explorer('clear');
						this.$parent.find('input[name="search_relationship_group"]').explorer('clear');
					}
				}
			});
		}

		this.$parent.find('input[name="search_relationship"]').explorer({
			url: process.env.REACT_APP_DOMAIN + '/api/relationship',
			additionalData: {
				limit: 30,
				page: 1
			},
			key: 'relationship',
			template: {
				list: function (product) {
					return window.Handlebars.compile('<div class="item">\n\t<div class="flex row">\n\t\t<div>\n\t\t\t<b>{{name}}</b>\n\t\t</div>\n\t</div>\n</div>')(product);
				},
				selected: {
					text: 'name',
					value: 'id',
					placeholder: 'เลือกคู่ค้า'
				}
			}
		});

		this.$parent.find('input[name="search_relationship_group"]').explorer({
			url: process.env.REACT_APP_DOMAIN + '/api/relationship/group',
			additionalData: {
				limit: 30,
				page: 1
			},
			key: 'relationship_group',
			template: {
				list: function (relationship_group) {
					return window.Handlebars.compile('<div class="item">\n\t<div class="flex row">\n\t\t<div>\n\t\t\t<b>{{name}}</b>\n\t\t</div>\n\t</div>\n</div>')(relationship_group);
				},
				selected: {
					text: 'name',
					value: 'id',
					placeholder: 'เลือกกลุ่มคู่ค้า'
				}
			}
		});
	}

	create() {
		let relationship_id = '';
		let relationship_group_id = '';

		if (this.$parent.find('input[name="is_relationship_group"]:checked').val() === '1') {
			relationship_group_id = this.$parent.find('input[name="search_relationship_group"]').val();
			if (!relationship_group_id) {
				return;
			}
		}
		if (this.$parent.find('input[name="is_relationship_group"]:checked').val() === '0') {
			relationship_id = this.$parent.find('input[name="search_relationship"]').val();
			if (!relationship_id) {
				return;
			}
		}

		if (this.$parent.find('.button').hasClass('loading')) {
			return;
		}
		this.$parent.find('.button').addClass('loading');

		window.Global.ajax({
			method: 'POST',
			url: process.env.REACT_APP_DOMAIN + '/api/product_display_permission',
			data: {
				product_display_id: this.state.product_display_id,
				is_allow: this.$parent.find('input[name="is_allow"]:checked').val(),
				relationship_id: relationship_id,
				relationship_group_id: relationship_group_id,
			},
			done: (response) => {
				this.$parent.find('.button').removeClass('loading');

				if (!response.success) {
					window.Global.showErrorOnForm(this.$parent, response.message);
					return false;
				}

				window.Global.messageTop({
					type: 'positive',
					message: 'เพิ่มรายชื่อเรียบร้อย'
				});

				let qs = window.Global.getAllQueryStrings();
				if (qs.page && qs.page !== '1') {
					//router.navigate('/permission/product_display/' + this.state.product_display_permission_id + '?page=1');
				} else {
					this.props.onCreated();
				}
			}
		});
	}

	render() {
		return (
			<div className="ui form tr Item_each"
			     ref={(ref) => {
				     this.ref = window.$(ref);
				     this.$parent = window.$(ref);
			     }}>
				<div className="td span12">
					<div>
						{
							!this.state.id
								?
								<div className="ui form" style={{padding: '1rem 0'}}>
									<h5 className="ui header dividing">เพิ่มรายชื่อ</h5>
									<div className="column inline fields">
										<label htmlFor="fruit">ประเภท:</label>
										<div className="field">
											<div className="ui radio checkbox"
											     data-form2_setup="true">
												<input type="radio"
												       name="is_relationship_group"
												       value="0"
												       defaultChecked={true}
												       tabIndex="0"
												       className="hidden"
												/>
												<label>คู่ค้า</label>
											</div>
										</div>
										<div className="field">
											<div className="ui radio checkbox"
											     data-form2_setup="true">
												<input type="radio"
												       name="is_relationship_group"
												       value="1"
												       tabIndex="0"
												       className="hidden"
												/>
												<label>กลุ่มคู่ค้า</label>
											</div>
										</div>
										<div className="field">
											<div className="ui radio checkbox"
											     data-form2_setup="true">
												<input type="radio"
												       name="is_relationship_group"
												       value="null"
												       tabIndex="0"
												       className="hidden"
												/>
												<label>คู่ค้าทุกคน</label>
											</div>
										</div>
									</div>
									<div className="column inline fields">
										<label htmlFor="fruit">ประเภท:</label>
										<div className="field">
											<div className="ui radio checkbox"
											     data-form2_setup="true">
												<input type="radio"
												       name="is_allow"
												       value="1"
												       defaultChecked={true}
												       tabIndex="0"
												       className="hidden"
												/>
												<label>แสดงข้อมูล</label>
											</div>
										</div>
										<div className="field">
											<div className="ui radio checkbox"
											     data-form2_setup="true">
												<input type="radio"
												       name="is_allow"
												       value="0"
												       tabIndex="0"
												       className="hidden"
												/>
												<label>ไม่แสดงข้อมูล</label>
											</div>
										</div>
									</div>
									<div id="relationship" className="field">
										<input type="text" name="search_relationship"/>
									</div>
									<div id="relationship_group" className="field" style={{display: 'none'}}>
										<input type="text" name="search_relationship_group"/>
									</div>
									<div className="field">
										<button type="button"
										        className="ui button blue"
										        onClick={() => {
											        this.create();
										        }}>บันทึก
										</button>
										<button type="button"
										        className="ui button red"
										        onClick={() => {
											        this.props.onDeleted();
										        }}>ยกเลิก
										</button>
									</div>
									<div className="ui error message"/>
								</div>
								: null
						}
						{
							this.state.id
								?
								<div>
									{
										this.state.relationship
											?
											<a href={process.env.REACT_APP_DOMAIN + "/relationships?id=" + this.state.relationship.id}
											   className="link">
												<span
													className="ui label green">คู่ค้า</span> {this.state.relationship.name}
											</a>
											: null
									}
									{
										this.state.relationship_group
											?
											<a href={"/relationship/group/" + this.state.relationship_group.id}
											   className="link">
											<span
												className="ui label black">กลุ่มคู่ค้า</span> {this.state.relationship_group.name}
											</a>
											: null
									}
									{
										this.state.relationship_id == null
										&& this.state.relationship_group_id == null
											?
											<span className="ui label blue">คู่ค้าทุกคน</span>
											: null
									}
									<div>
										<input type="hidden"
										       name="item[][relationship_id]"
										       defaultValue={this.state.relationship_id}/>
										<input type="hidden"
										       name="item[][relationship_group_od]"
										       defaultValue={this.state.relationship_group_id}/>
									</div>
								</div>
								: null
						}
					</div>
				</div>
				<div className="td span4">
					<div className="flex row middle-xs">
						{
							this.state.id
								?
								this.state.is_allow
									? <span className="ui label green">แสดงข้อมูล</span>
									: <span className="ui label red">ไม่แสดงข้อมูล</span>
								: null
						}
						{
							this.state.id
							&& this.state.weight === 1
								? <span className="ui label basic">สำคัญต่ำสุด</span>
								: null
						}
						{
							this.state.id
							&& this.state.weight === 2
								? <span className="ui label basic">สำคัญปานกลาง</span>
								: null
						}
						{
							this.state.id
							&& this.state.weight === 3
								? <span className="ui label basic">สำคัญสูงสุด</span>
								: null
						}
						<div className="ui icon button right floated remove"
						     onClick={() => {
							     if (!this.state.id) {
								     this.props.onDeleted();
								     return false;
							     }
							     window.Global.confirm({
								     title: 'ยืนยันลบสิทธิ์',
								     content: '<form class="ui form">\n\t<p>โปรดยืนยันลบสิทธิ์ การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>',
								     cancel_text: 'ไม่ดำเนินการ',
								     approve_text: 'ลบสิทธิ์',
								     onShowToSetupForm: ($modal) => {
									     $modal.find('form').form2('setup');
									     $modal.find('form').form2('submit', {
										     method: 'DELETE',
										     url: process.env.REACT_APP_DOMAIN + '/api/product_display_permission',
										     loadingButton: $modal.find('.button.approve'),
										     beforeSent: (data) => {
											     data.product_display_permission_id = this.state.id;
											     return data;
										     },
										     onSuccess: () => {
											     $modal.modal('hide');
											     window.Global.messageTop({
												     type: 'positive',
												     message: 'ยกเลิกเรียบร้อย'
											     });
											     this.props.onCreated();
										     }
									     });
								     }
							     });
						     }}>
							<i className="remove icon"/>
						</div>
					</div>
				</div>
			</div>
		)
	}
}